import configureAppStore from './configureStore'
export default configureAppStore()